import ProductDisplay from './ProductDisplay';
import CardsDisplay from './CardsDisplay';
import CourseDisplay from './Course';
import CarouselDisplay from './CarouselDisplay';
import MatDisplay from './MatDisplay';
import FeaturedDisplay from './FeaturedDisplay';

export default ProductDisplay;
export { CardsDisplay, CourseDisplay, CarouselDisplay, MatDisplay, FeaturedDisplay };
